// @ts-nocheck

import { type StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { type BoomGlobalState } from '../../reducers/boom';
import { type BoomGlobalStatus } from '../../types/global';
import { type BoomSkinId } from '../../types/global';
import { selectBoomState } from '../boom/boomPrimary.selector';

const emptyObj = {};

export const selectBoomGlobalState: Selector<BoomGlobalState> = (state: StateType) =>
  selectBoomState(state)?.global ?? emptyObj;

export const selectBoomGlobalStatus: Selector<BoomGlobalStatus | undefined> = (state: StateType) =>
  selectBoomGlobalState(state)?.status;

export const selectBoomGlobalVersion: Selector<number | null | undefined> = (state: StateType) =>
  selectBoomGlobalState(state)?.version;

export const selectBoomGlobalOperationEndDate: Selector<number | undefined> = (state: StateType) =>
  selectBoomGlobalState(state)?.operationEndDate;

export const selectBoomGlobalOperationStartDate: Selector<number | undefined> = (state: StateType) =>
  selectBoomGlobalState(state)?.operationStartDate;

export const selectBoomGlobalBoomId: Selector<string> = (state: StateType) => selectBoomGlobalState(state)?.boomId;

export const selectBoomGlobalSkinId: Selector<BoomSkinId> = (state: StateType) => selectBoomGlobalState(state)?.skinId;

export const selectBoomGlobalMaxWinningAmount: Selector<number | null | undefined> = (state: StateType) =>
  selectBoomGlobalState(state)?.maxWinningAmount;

export const selectBoomGlobalStakeMaxRefAmount: Selector<number | null | undefined> = (state: StateType) =>
  selectBoomGlobalState(state)?.stakeMaxRefAmount;
